/* Sport Sun — sticky PDP bar helpers
 *
 * 1. BUY NOW proxy. gokwik-buy-now.liquid renders id="gokwik-buy-now" and gokwik.liquid binds
 *    it via getElementById, so the sticky bar cannot contain its own copy. The proxy stays
 *    hidden until the real button exists and becomes visible, then mirrors its enabled state
 *    and forwards clicks to it.
 * 2. Click-to-copy on the offer stripe's discount code.
 */
(function () {
  'use strict';

  var REAL_BUY_NOW_ID = 'gokwik-buy-now';

  function realBuyNow() {
    return document.getElementById(REAL_BUY_NOW_ID);
  }

  function isUsable(el) {
    if (!el) return false;
    if (el.disabled || el.classList.contains('disabled')) return false;
    // Gokwik hides the button outright when its flow is unavailable.
    if (el.offsetParent === null && getComputedStyle(el).position !== 'fixed') return false;
    return true;
  }

  function syncBuyNow() {
    var proxies = document.querySelectorAll('[data-ss-buynow]');
    if (!proxies.length) return;

    var real = realBuyNow();
    var usable = isUsable(real);

    for (var i = 0; i < proxies.length; i++) {
      proxies[i].hidden = !usable;
    }
  }

  function onProxyClick(event) {
    var proxy = event.target.closest('[data-ss-buynow]');
    if (!proxy) return;

    var real = realBuyNow();
    if (!isUsable(real)) {
      // Nothing to forward to — let the shopper fall back to Add to cart rather than dead-end.
      syncBuyNow();
      return;
    }

    event.preventDefault();
    real.click();
  }

  function onCopyClick(event) {
    var btn = event.target.closest('[data-ss-copy]');
    if (!btn) return;

    event.preventDefault();
    var code = btn.getAttribute('data-ss-copy') || '';
    if (!code) return;

    var done = function () {
      btn.setAttribute('data-copied-label', 'Copied');
      btn.classList.add('is-copied');
      setTimeout(function () {
        btn.classList.remove('is-copied');
      }, 1600);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, function () {});
      return;
    }

    // Older mobile browsers: fall back to a throwaway textarea.
    try {
      var ta = document.createElement('textarea');
      ta.value = code;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      done();
    } catch (e) {
      /* Clipboard unavailable — the code is still visible on screen to type manually. */
    }
  }

  function init() {
    document.addEventListener('click', onProxyClick);
    document.addEventListener('click', onCopyClick);

    syncBuyNow();

    // Gokwik injects and toggles its button asynchronously, so re-check as the DOM settles
    // rather than assuming it is present at load.
    var real = realBuyNow();
    if (window.MutationObserver) {
      var target = real || document.body;
      new MutationObserver(syncBuyNow).observe(target, {
        attributes: true,
        attributeFilter: ['class', 'disabled', 'style'],
        childList: !real,
        subtree: !real
      });
    }

    var tries = 0;
    var poll = setInterval(function () {
      syncBuyNow();
      if (++tries >= 10) clearInterval(poll);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
